import React, { useState } from "react";
import { Layout, Menu } from "antd";
import { Link, useLocation } from "react-router-dom";

import logo from "../../../assets/dental-inden/images/dentalID-Logo.svg";
import collapsedlogo from "../../../assets/dental-inden/images/dentalID-collapsed.svg";
import collapsedOpen from "../../../assets/dental-inden/icons/collapsedOpen.svg";
import collapsedClose from "../../../assets/dental-inden/icons/collapsedClose.svg";
import projectIcon from "../../../assets/dental-inden/icons/projects.svg";
import dashboardIcon from "../../../assets/dental-inden/icons/dashboard.svg";
import servicesIcon from "../../../assets/dental-inden/icons/servicesIcon.svg";
import logoutIcon from "../../../assets/dental-inden/icons/logoutIcon.svg";
import profileIcon from "../../../assets/dental-inden/icons/profileIcon.svg";
import aboutUsIcon from "../../../assets/dental-inden/icons/aboutUsIcon.svg";
import settingsIcon from "../../../assets/dental-inden/icons/settingsIcon.svg";
import supportIcon from "../../../assets/dental-inden/icons/supportIcon.svg";
import tutorialsIcon from "../../../assets/age-assessment/icons/tutorials.svg";
import ourPartnerIcon from "../../../assets/age-assessment/icons/ourPartner.svg";
import faqsIcon from "../../../assets/age-assessment/icons/faqs.svg";

import { useDispatch, useSelector } from "react-redux";
import { _toggleSideMenu } from "../../../redux/actions/profileSettingsAction";
import { _authenticateUser } from "../../../redux/actions/authAction";

const { Sider } = Layout;

const AgeAssessmentSideBar = () => {
  const dispatch = useDispatch();
  const location = useLocation(); // Get the current location (URL)
  const collapsed = useSelector(
    (state) => state.settings_data?.isToggleSideMenu
  );
  // const privileges = useSelector((state) => state.auth?.privileges);
  const userdata = useSelector(
    (state) => state.settings_data.profileSettings_data
  );
  const isDentalRecordScreen = useSelector(
    (state) => state.general.isDentalRecordScreen || false
  );
  const [showOtherModules, setShowOtherModules] = useState(false);
  const toggleCollapse = () => {
    dispatch(_toggleSideMenu(!collapsed));
  };

  const iconList = [
    {
      name: "services",
      src: servicesIcon,
      label: "Modules",
      path: "/",
      key: "module",
    },
    {
      name: "dashboard",
      src: dashboardIcon,
      label: "Dashboard",
      path: "/dashboard",
    },
    {
      name: "cases",
      src: projectIcon,
      label: "Cases",
      path: "/cases",
    },
    {
      name: "tutorial",
      src: tutorialsIcon,
      label: "Tutorial",
      path: "/tutorial",
    },

    // {
    //   name: "ourPartners",
    //   src: ourPartnerIcon,
    //   label: "Our Partners",
    //   path: "/our-partners",
    // },
    {
      name: "faqs",
      src: faqsIcon,
      label: "FAQ's",
      path: "/faqs",
    },
    {
      name: "settings",
      src: settingsIcon,
      label: "Settings",
      path: "/settings",
    },
    {
      name: "contactUs",
      src: supportIcon,
      label: "Contact Us",
      path: "/support",
    },

    // Add more icons dynamically here
  ];

  // // Map over the icon list to generate the menu items dynamically
  const menuItems = iconList.map((icon) => ({
    key: `/age-assessment${icon.path}`,
    label: (
      <Link to={icon.name === "services" ? "/" : `/age-assessment${icon.path}`}>
        {icon.label}
      </Link>
    ),
    icon: <img src={icon.src} alt={icon.name} />,
  }));
  // Map over the icon list to generate the menu items dynamically
  // const menuItems = iconList.map((icon) => {
  //   if (icon.name === "services") {
  //     return {
  //       key: "modules",
  //       label: (
  //         <div
  //           onClick={() => setShowOtherModules(!showOtherModules)} // 👈 your alert logic here
  //           style={{ cursor: "pointer" }}
  //         >
  //           {icon.label}
  //         </div>
  //       ),
  //       icon: <img src={icon.src} alt={icon.name} />,
  //     };
  //   } else {
  //     return {
  //       key: `/age-assessment${icon.path}`,
  //       label: <Link to={`/age-assessment${icon.path}`}>{icon.label}</Link>,
  //       icon: <img src={icon.src} alt={icon.name} />,
  //     };
  //   }
  // });

  const handleLogout = () => {
    localStorage.removeItem("user");
    dispatch(_authenticateUser(false));
  };

  return (
    <Sider
      style={{
        display: isDentalRecordScreen ? "none" : "block",
        position: "relative",
      }}
      theme="light"
      width={200}
      collapsible
      collapsed={collapsed}
      onCollapse={toggleCollapse}
      className="side_bar"
      trigger={null} // This hides the default collapse trigger icon
    >
      {/* Top section: "Admin Panel" text with collapse icon */}
      <div className={`logoAndCollapse ${collapsed ? "collapsed" : ""}`}>
        {/* Collapse icon and text inside the same ection */}
        <Link to="/">
          <div className={`logo-section ${collapsed ? "collapsed" : ""}`}>
            <img src={collapsed ? collapsedlogo : logo} alt="logo" />
          </div>
        </Link>

        <div
          style={{
            cursor: "pointer",
          }}
          onClick={toggleCollapse}
        >
          {collapsed ? (
            <img src={collapsedOpen} />
          ) : (
            <img src={collapsedClose} />
          )}
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          marginTop: 60,
          marginLeft: collapsed ? 20 : 0,
        }}
      >
        {!collapsed && (
          // <Link to={"/subscription"}>
          <p
            style={{
              fontSize: collapsed ? 14 : 16,
              color: "#20C3FF",
              fontFamily: "Poppins-Medium",
              textDecoration: "underLine",
            }}
          >
            {userdata?.organization?.name}
          </p>
          // </Link>
        )}
      </div>

      {/* Menu items */}
      <Menu
        theme="light"
        mode="inline"
        defaultSelectedKeys={["/dashboard"]}
        selectedKeys={[location.pathname]} // Dynamically set the selected key based on the URL
        items={menuItems}
        style={{ marginTop: 0 }} // Adjust margin to prevent overlap with the top section
      />
      <div
        className="side_menu_logout_section"
        onClick={handleLogout}
        style={{ marginLeft: collapsed ? 7 : 0, marginTop: 5 }}
      >
        <img src={logoutIcon} />
        {!collapsed && <p>Logout</p>}
      </div>
      {/* {showOtherModules && (
        <div className="absolute top-[20%] z-[99] bg-white h-[200px] w-[180px] left-[20px] shadow-md rounded-md">
          modules
        </div>
      )} */}
    </Sider>
  );
};

export default AgeAssessmentSideBar;

// import React from "react";
// import { Layout, Menu } from "antd";
// import { Link, useLocation } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";

// import logo from "../../../assets/dental-inden/images/dentalID-Logo.svg";
// import collapsedlogo from "../../../assets/dental-inden/images/dentalID-collapsed.svg";
// import collapsedOpen from "../../../assets/dental-inden/icons/collapsedOpen.svg";
// import collapsedClose from "../../../assets/dental-inden/icons/collapsedClose.svg";
// import projectIcon from "../../../assets/dental-inden/icons/projects.svg";
// import dashboardIcon from "../../../assets/dental-inden/icons/dashboard.svg";
// import servicesIcon from "../../../assets/dental-inden/icons/servicesIcon.svg";
// import logoutIcon from "../../../assets/dental-inden/icons/logoutIcon.svg";
// import settingsIcon from "../../../assets/dental-inden/icons/settingsIcon.svg";
// import supportIcon from "../../../assets/dental-inden/icons/supportIcon.svg";
// import tutorialsIcon from "../../../assets/age-assessment/icons/tutorials.svg";
// import faqsIcon from "../../../assets/age-assessment/icons/faqs.svg";

// import { _toggleSideMenu } from "../../../redux/actions/profileSettingsAction";
// import { _authenticateUser } from "../../../redux/actions/authAction";

// const { Sider } = Layout;

// const AgeAssessmentSideBar = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const collapsed = useSelector(
//     (state) => state.settings_data?.isToggleSideMenu
//   );
//   const userdata = useSelector(
//     (state) => state.settings_data.profileSettings_data
//   );
//   const isDentalRecordScreen = useSelector(
//     (state) => state.general.isDentalRecordScreen || false
//   );

//   const toggleCollapse = () => dispatch(_toggleSideMenu(!collapsed));
//   const handleLogout = () => {
//     localStorage.removeItem("user");
//     dispatch(_authenticateUser(false));
//   };

//   // Main icon list
//   const iconList = [
//     {
//       name: "services",
//       src: servicesIcon,
//       label: "Modules",
//       path: "/",
//       children: [
//         {
//           label: "Dental Analysis",
//           path: "dental-analysis/projects",
//           src: servicesIcon,
//         },
//         {
//           label: "Dental Indentification",
//           path: "dental-identification/dashboard",
//           src: servicesIcon,
//         },
//         {
//           label: "Second Opinion",
//           path: "ai-measurement",
//           src: servicesIcon,
//         },
//       ],
//     },
//     {
//       name: "dashboard",
//       src: dashboardIcon,
//       label: "Dashboard",
//       path: "/dashboard",
//     },
//     {
//       name: "cases",
//       src: projectIcon,
//       label: "Cases",
//       path: "/cases",
//     },
//     {
//       name: "tutorial",
//       src: tutorialsIcon,
//       label: "Tutorial",
//       path: "/tutorial",
//     },
//     {
//       name: "faqs",
//       src: faqsIcon,
//       label: "FAQ's",
//       path: "/faqs",
//     },
//     {
//       name: "settings",
//       src: settingsIcon,
//       label: "Settings",
//       path: "/settings",
//     },
//     {
//       name: "contactUs",
//       src: supportIcon,
//       label: "Contact Us",
//       path: "/support",
//     },
//   ];

//   // Convert to AntD menu items (supports submenus)
//   const menuItems = iconList.map((icon) => {
//     if (icon.children) {
//       return {
//         key: icon.name,
//         icon: <img src={icon.src} alt={icon.name} />,
//         label: icon.label,
//         children: icon.children.map((child) => ({
//           key: `${child.path}`,
//           label: <Link to={`/${child.path}`}>{child.label}</Link>,
//         })),
//       };
//     }

//     return {
//       key: `/age-assessment${icon.path}`,
//       icon: <img src={icon.src} alt={icon.name} />,
//       label: <Link to={`/age-assessment${icon.path}`}>{icon.label}</Link>,
//     };
//   });

//   return (
//     <Sider
//       style={{
//         display: isDentalRecordScreen ? "none" : "block",
//         position: "relative",
//       }}
//       theme="light"
//       width={200}
//       collapsible
//       collapsed={collapsed}
//       onCollapse={toggleCollapse}
//       className="side_bar"
//       trigger={null}
//     >
//       {/* Header */}
//       <div className={`logoAndCollapse ${collapsed ? "collapsed" : ""}`}>
//         <Link to="/">
//           <div className={`logo-section ${collapsed ? "collapsed" : ""}`}>
//             <img src={collapsed ? collapsedlogo : logo} alt="logo" />
//           </div>
//         </Link>
//         <div style={{ cursor: "pointer" }} onClick={toggleCollapse}>
//           <img src={collapsed ? collapsedOpen : collapsedClose} />
//         </div>
//       </div>

//       {/* Organization Name */}
//       <div
//         style={{
//           width: "100%",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           marginTop: 60,
//           marginLeft: collapsed ? 20 : 0,
//         }}
//       >
//         {!collapsed && (
//           <p
//             style={{
//               fontSize: collapsed ? 14 : 16,
//               color: "#20C3FF",
//               fontFamily: "Poppins-Medium",
//               textDecoration: "underline",
//             }}
//           >
//             {userdata?.organization?.name}
//           </p>
//         )}
//       </div>

//       {/* Menu */}
//       <Menu
//         theme="light"
//         mode="inline"
//         defaultSelectedKeys={["/dashboard"]}
//         selectedKeys={[location.pathname]}
//         items={menuItems}
//         style={{ marginTop: 0 }}
//       />

//       {/* Logout */}
//       <div
//         className="side_menu_logout_section"
//         onClick={handleLogout}
//         style={{ marginLeft: collapsed ? 7 : 0, marginTop: 5 }}
//       >
//         <img src={logoutIcon} />
//         {!collapsed && <p>Logout</p>}
//       </div>
//     </Sider>
//   );
// };

// export default AgeAssessmentSideBar;
